import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BlocksHelper {

  tclasses = [
    {id: 'T0', tcu: 'T0', description: 'T0 - Full Performance'},
    {id: 'T2', tcu: 'T2', description: 'T2 - Forced Outage'},
    {id: 'T2.1', tcu: 'T2', description: 'T2.1 - Forced Outage - Assigned to Windfarm operator'},
    {
      id: 'T2.2',
      tcu: 'T2',
      description: 'T2.2 - Forced Outage - Assigned to Service Company or Manufacturer'
    },
    {id: 'T3', tcu: 'T3', description: 'T3 - Scheduled Maintenance GENERAL'},
    {id: 'T3.1', tcu: 'T3', description: 'T3.1 - Scheduled Maintenance ALLOWANCES'},
    {id: 'T4', tcu: 'T4', description: 'T4 - Out of Electrical Specification'},
    {id: 'T4.1', tcu: 'T4', description: 'T4.1 - Out of Electrical Specification - Grid Failure'},
    {id: 'T4.2', tcu: 'T4', description: 'T4.2 - Out of Electrical Specification - Electrical BOP failure'},
    {id: 'T5', tcu: 'T5', description: 'T5 - Out of Environmental Specificacion - Storm'},
    {id: 'T6', tcu: 'T6', description: 'T6 - Out of Environmental Specificacion - Calm Wind'},
    {id: 'T10', tcu: 'T10', description: 'T10 - Planned Corrective Action'},
    {id: 'T10.0', tcu: 'T10', description: 'T10.0 - Planned Corrective Action - General'},
    {id: 'T10.1', tcu: 'T10', description: 'T10.1 - Planned Corrective Action - Waiting Spare Parts'},
    {id: 'T11', tcu: 'T11', description: 'T11 - Technical Standby'},
    {id: 'T12', tcu: 'T12', description: 'T12 - Partial Performance'},
    {id: 'T12.0', tcu: 'T12', description: 'T12.0 - Partial Performance - Derated - GENERAL'},
    {id: 'T12.1', tcu: 'T12', description: 'T12.1 - Partial Performance - Derated by Grid operator'},
    {id: 'T12.2', tcu: 'T12', description: 'T12.2 - Partial Performance - Derated by Direct Marketer'},
    {id: 'T12.30', tcu: 'T12', description: 'T12.30 - Partial Performance - Derated by Windfarm Operator'},
    {
      id: 'T12.31',
      tcu: 'T12',
      description: 'T12.31 - Partial Performance - Derated by Windfarm operator due to noise'
    },
    {
      id: 'T12.32',
      tcu: 'T12',
      description: 'T12.32 - Partial Performance - Derated by Windfarm operator due to ice'
    },
    {id: 'T12.4', tcu: 'T12', description: 'T12.4 - Partial Performance - Derated by Manufacturer'},
    {id: 'T14', tcu: 'T14', description: 'T14 - Requested Shutdown'},
    {id: 'T14.0', tcu: 'T14', description: 'T14.0 - Requested Shutdown - GENERAL'},
    {id: 'T14.1', tcu: 'T14', description: 'T14.1 - Requested Shutdown - By Grid Operator'},
    {id: 'T14.2', tcu: 'T14', description: 'T14.2 - Requested Shutdown - By Direct Marketer'},
    {id: 'T14.30', tcu: 'T14', description: 'T14.30 - Requested Shutdown - By Wind Farm Operator - GENERAL'},
    {id: 'T14.31', tcu: 'T14', description: 'T14.31 - Requested Shutdown - By Wind Farm Operator due to noise'},
    {id: 'T14.32', tcu: 'T14', description: 'T14.32 - Requested Shutdown - By Wind Farm Operator due to ice'},
    {id: 'T14.33', tcu: 'T14', description: 'T14.33 - Requested Shutdown - By Wind Farm Operator due to Avifauna'},
    {id: 'T14.34', tcu: 'T14', description: 'T14.34 - Requested Shutdown - By Wind Farm Operator due to shadow'},
    {id: 'T14.4', tcu: 'T14', description: 'T14.4 - Requested Shutdown - By Manufacturer'},
    {id: 'T17', tcu: 'T17', description: 'T17 - Suspended'},
    {id: 'T18', tcu: 'T18', description: 'T18 - Force Majeure'},
    {id: 'T99', tcu: 'T99', description: 'T99 - Information Unavailable'},
    {id: 'T99.0', tcu: 'T99', description: 'T99.0 - Information Unavailable - GENERAL'},
    {id: 'T99.1', tcu: 'T99', description: 'T99.1 - Information Unavailable - SCADA Failure'},
    {id: 'T99.2', tcu: 'T99', description: 'T99.2 - Information Unavailable - Loss Of Comunication'}
  ];

  blockColors = [
    {
      class: 'T0',
      backgroundColor: '#00cc6b0c',
      highligthColor: '#00cc6b33',
      lineColor: '#00cc6b',
      lineHighlightColor: '#00cc6bee',
      cssVarColor: 'tclass-t0'
    },
    {
      class: 'T2',
      backgroundColor: '#f62d580c',
      highligthColor: '#f62d5833',
      lineColor: '#f62d58',
      lineHighlightColor: '#f62d58ee',
      cssVarColor: 'tclass-t2'
    },
    {
      class: 'T3',
      backgroundColor: '#0085c20c',
      highligthColor: '#0085c233',
      lineColor: '#0085c2',
      lineHighlightColor: '#0085c2ee',
      cssVarColor: 'tclass-t3'
    },
    {
      class: 'T4',
      backgroundColor: '#fcdf380c',
      highligthColor: '#fcdf3833',
      lineColor: '#fcdf38',
      lineHighlightColor: '#fcdf38ee',
      cssVarColor: 'tclass-t4'
    },
    {
      class: 'T5',
      backgroundColor: '#ffe0000c',
      highligthColor: '#ffe00033',
      lineColor: '#ffe000',
      lineHighlightColor: '#ffe000ee',
      cssVarColor: 'tclass-t5'
    },
    {
      class: 'T6',
      backgroundColor: '#ceb6190c',
      highligthColor: '#ceb61933',
      lineColor: '#ceb619',
      lineHighlightColor: '#ceb619ee',
      cssVarColor: 'tclass-t6'
    },
    // {
    //   class: 'T7',
    //   backgroundColor: '#00e0740c',
    //   highligthColor: '#00e07433',
    //   lineColor: '#00e074',
    //   lineHighlightColor: '#00e074ee'
    // },
    {
      class: 'T10',
      backgroundColor: '#00ceff0c',
      highligthColor: '#00ceff33',
      lineColor: '#00ceff',
      lineHighlightColor: '#00ceffee',
      cssVarColor: 'tclass-t10'
    },
    {
      class: 'T11',
      backgroundColor: '#ffe85d0c',
      highligthColor: '#ffe85d33',
      lineColor: '#ffe85d',
      lineHighlightColor: '#ffe85dee',
      cssVarColor: 'tclass-t11'
    },
    {
      class: 'T12',
      backgroundColor: '#7c3f7c0c',
      highligthColor: '#7c3f7c33',
      lineColor: '#7c3f7c',
      lineHighlightColor: '#7c3f7cee',
      cssVarColor: 'tclass-t12'
    },
    {
      class: 'T14',
      backgroundColor: '#9882000c',
      highligthColor: '#98820033',
      lineColor: '#988200',
      lineHighlightColor: '#988200ee',
      cssVarColor: 'tclass-t14'
    },
    {
      class: 'T17',
      backgroundColor: '#ff696f0c',
      highligthColor: '#ff696f33',
      lineColor: '#ff696f',
      lineHighlightColor: '#ff696fee',
      cssVarColor: 'tclass-t17'
    },
    {
      class: 'T18',
      backgroundColor: '#ffa9ac0c',
      highligthColor: '#ffa9ac33',
      lineColor: '#ffa9ac',
      lineHighlightColor: '#ffa9acee',
      cssVarColor: 'tclass-t18'
    },
    {
      class: 'T99',
      backgroundColor: '#8888880c',
      highligthColor: '#88888833',
      lineColor: '#888888',
      lineHighlightColor: '#888888ee',
      cssVarColor: 'tclass-t99'
    }
  ];

  maintainColors = [
    {
      type: 'Maintenance',
      color: '#4a90e2'
    },
    {
      type: 'Repairs',
      color: '#56ccff'
    },
    {
      type: 'Grid Limitation',
      color: '#7c3f7c'
    },
    {
      type: 'Environmental',
      color: '#187175'
    },
    {
      type: 'Inspection',
      color: '#F46B39'
    }
  ];

  tClassesNames = [
    {id: 'T0', description: 'T0 - Full Performance'},
    {id: 'T2', description: 'T2 - Forced Outage'},
    {id: 'T3', description: 'T3 - Scheduled Maintenance'},
    {id: 'T4', description: 'T4 - Out of Electrical Specification'},
    {id: 'T5', description: 'T5 - Storm'},
    {id: 'T6', description: 'T6 - No Wind'},
    // {id: 'T7', description: 'T7 - Full Performance - Failure/warning without Downtime'},
    {id: 'T10', description: 'T10 - Planned Corrective Action'},
    {id: 'T11', description: 'T11 - Technical Standby'},
    {id: 'T12', description: 'T12 - Partial Performance'},
    {id: 'T14', description: 'T14 - Requested Shutdown'},
    {id: 'T17', description: 'T17 - Suspended'},
    {id: 'T18', description: 'T18 - Force Majeure'},
    {id: 'T99', description: 'T99 - Information Unavailable'}
  ];
}
